export const FISHING_CAT = process.env.REACT_APP_FISHING_CAT;
export const PALLAS_CAT = process.env.REACT_APP_PALLAS_CAT;
export const SAND_CAT = process.env.REACT_APP_SAND_CAT;
export const SAND_CAT_WS = process.env.REACT_APP_SAND_CAT_WS;

export const USER_AUTH_DOMAIN = "user-auth.mhome.ai";
export const DEV_AUTH_DOMAIN = "dev-auth.mhome.ai";
